import clsx from 'classnames';
import React from 'react';

type DetailProps = {
  icon: React.ReactNode;
  title: string;
  description: React.ReactNode;
  iconSize?: number;
  gap?: number;
  decorativeIcon?: boolean;
  className?: string;
};

const Detail: React.FC<DetailProps> = ({
  icon,
  title,
  description,
  iconSize = 40,
  gap = 16,
  decorativeIcon = true,
  className,
}) => (
  <div
    className={clsx('detail', className)}
    style={
      {
        '--dt-size': `${iconSize}px`,
        '--dt-gap': `${gap}px`,
      } as React.CSSProperties
    }
  >
    <span className="detail__icon" aria-hidden={decorativeIcon}>
      {icon}
    </span>
    <div className="detail__text">
      <div className="detail__title">{title}</div>
      <div className="detail__desc">{description}</div>
    </div>
  </div>
);

export default Detail;
